import React, { useState, useEffect } from 'react';
import { Button } from 'primereact/button';
import { DataTable } from 'primereact/datatable';
import { Column } from 'primereact/column';
import { Toolbar } from 'primereact/toolbar';
import { InputText } from 'primereact/inputtext';
import PieceRechangeService from '../services/PieceRechangeService';
import { itemPerPage } from '../baseUrls/consts';


const PieceRechangeStock = () => {
    return (
        <div>
            <div className="card">
                <Table />
            </div>
        </div>
    );
}

const Table = (props) => {
    const [items, setItems] = useState([]);
    const [globalFilter, setGlobalFilter] = useState(null);
    const [loading, setLoading] = useState(true);

    const [first, setFirst] = useState(0);
    const [rows, setRows] = useState(itemPerPage);

    const onPageChange = (event) => {
        setFirst(event.first);
        setRows(event.rows);
    };

    useEffect(() => {
        loadItems();
    }, []);

    const loadItems = () => {
        PieceRechangeService.getStock((data, status) => {
                setLoading(false);
                if(status) setItems(data);   
            },
            {size: itemPerPage}
        );
    }

    
    return (
        <>
            <h5>Stock des pièces de rechanges</h5>
            <Toolbar className="mb-4" 
                left={
                    <React.Fragment>
                        <div className="my-2">
                            <Button label="Actualiser" icon="pi pi-refresh" className="p-button-primry mr-2" 
                                onClick={()=>{setLoading(true); loadItems()}} />
                        </div>
                    </React.Fragment>
                } 
                right={
                    <React.Fragment>
                        <span className="block mt-2 md:mt-0 p-input-icon-left">
                            <i className="pi pi-search" />
                            <InputText type="search" placeholder="Recherche..." onInput={(e) => setGlobalFilter(e.target.value)} />
                        </span>
                    </React.Fragment>
                } />
            <DataTable dataKey="id" value={items} 
                paginator rows={itemPerPage} /*first={first}  
                totalRecords={120} rowsPerPageOptions={[5, 10, 20, 30]} onPageChange={onPageChange}*/
                loading={loading} globalFilter={globalFilter} 
                responsiveLayout="scroll" emptyMessage="Aucune donnée disponible.">

                <Column field="id" header="Identifiant" hidden sortable />
                <Column field="codePiece" header="Code pièce" sortable hidden/>
                <Column field="dateMouvement" header="Date " sortable 
                     body={(item)=> new Date(item.dateMouvement).toLocaleDateString()}/>
                <Column field="piece.libellePiece" header="Pièce" sortable />
                <Column field="quantite" header="Quantité" sortable style={{fontWeight: 'bold'}} />
                <Column field="sensMouvement" header="Sens mouvement" sortable body={ (item)=> 
                    <span className={`customer-badge status-${item.sensMouvement === 'SORTIE'? 'proposal' : 'qualified'}`}>
                        {item.sensMouvement}
                    </span>
                } />
                <Column field="institution.libelle" header="Institution" sortable style={{fontWeight: 'bold'}} />
            </DataTable>
        </>
    );
}

export default PieceRechangeStock;